import _ from 'lodash';
export const defaultColorPalette = {
    RED: ['#F9B3B9', '#F47E89', '#F04152', '#B6313E', '#721F27'],
    PURPLE: ['#D1C0FB', '#B094F8', '#8C62F5', '#6A4ABA', '#422E75'],
    BLUE: ['#ABC7F9', '#71A1F4', '#2E75F0', '#2359B6', '#163772'],
    TEAL: ['#B5ECF2', '#82DFE9', '#48D1E0', '#369FAA', '#22636B'],
    YELLOW: ['#FDE9AF', '#FCD977', '#FCC838', '#BF982A', '#785F1A'],
    GREY: ['#BEC6D0', '#A2ACBA', '#747E8C', '#47515F', '#2F3947'],
    GREEN: ['#9BE5CB', '#56D3A8', '#06BF7F', '#049160', '#025B3C'],
    ORANGE: ['#FFCCB3', '#FFA97E', '#FF8142', '#C26232', '#7A3D1F'],
};
export const defaultFullColorPalette = {
    WHITE: [
        '#FFFFFF',
        '#EAEDF2',
        '#DBDFE7',
        '#C0C6CF',
        '#A5ACB9',
        '#777E8B',
        '#4A515E',
        '#323946',
        '#1C2330',
        '#000000',
    ],
    RED: [
        '#FFF0F0',
        '#FCE6E8',
        '#FCD2D5',
        '#F9B3B9',
        '#F47E89',
        '#F04152',
        '#B6313E',
        '#721F27',
        '#3D090E',
        '#1F0003',
    ],
    ORANGE: [
        '#FFF5F0',
        '#FFEEE5',
        '#FFDDCC',
        '#FFCCB3',
        '#FFA97E',
        '#FF8142',
        '#C26232',
        '#7A3D1F',
        '#471F0B',
        '#2E0F00',
    ],
    PURPLE: [
        '#F7F5FF',
        '#F0EBFF',
        '#E3D9FC',
        '#D1C0FB',
        '#B094F8',
        '#8C62F5',
        '#6A4ABA',
        '#422E75',
        '#210F4F',
        '#0D0030',
    ],
    GREEN: [
        '#EDFFF9',
        '#E1FAF1',
        '#C7F2E3',
        '#9BE5CB',
        '#56D3A8',
        '#06BF7F',
        '#049160',
        '#025B3C',
        '#003B26',
        '#001F14',
    ],
    YELLOW: [
        '#FFFBF0',
        '#FFF8E3',
        '#FCF0CC',
        '#FCE7AC',
        '#FCD977',
        '#FCC838',
        '#BF982A',
        '#785F1A',
        '#4F3D09',
        '#2B2000',
    ],
    TEAL: [
        '#EDFDFF',
        '#E1F7FA',
        '#C9F0F5',
        '#B3EAF0',
        '#82DFE9',
        '#48D1E0',
        '#369FAA',
        '#22636B',
        '#0C3F45',
        '#00272B',
    ],
    BLUE: [
        '#F2F7FF',
        '#E6EDFA',
        '#CEDCF5',
        '#ABC7F9',
        '#71A1F4',
        '#2E75F0',
        '#2359B6',
        '#163772',
        '#082559',
        '#00153B',
    ],
};
export const defaultExtendedColorPalette = {
    RED: [
        '#f9b3ba',
        '#f68d97',
        '#f36775',
        '#F04152',
        '#c03442',
        '#902731',
        '#601a21',
    ],
    PURPLE: [
        '#d1c0fb',
        '#baa1f9',
        '#a381f7',
        '#8C62F5',
        '#704ec4',
        '#543b93',
        '#382762',
    ],
    BLUE: [
        '#abc8f9',
        '#82acf6',
        '#5891f3',
        '#2E75F0',
        '#255ec0',
        '#1c4690',
        '#122f60',
    ],
    TEAL: [
        '#b6edf3',
        '#91e3ec',
        '#6ddae6',
        '#48D1E0',
        '#3aa7b3',
        '#2b7d86',
        '#1d545a',
    ],
    YELLOW: [
        '#fee9af',
        '#fdde88',
        '#fdd360',
        '#FCC838',
        '#caa02d',
        '#977822',
        '#655016',
    ],
    GREY: [
        '#c7cbd1',
        '#acb2ba',
        '#9098a3',
        '#747E8C',
        '#5d6570',
        '#464c54',
        '#2e3238',
    ],
    GREEN: [
        '#9be5cc',
        '#6ad9b2',
        '#38cc99',
        '#06BF7F',
        '#059966',
        '#04734c',
        '#024c33',
    ],
    ORANGE: [
        '#ffcdb3',
        '#ffb38e',
        '#ff9a68',
        '#FF8142',
        '#cc6735',
        '#994d28',
        '#66341a',
    ],
};
export const COLOR_FULL_HUE_COUNT = 10;
export const COLOR_HUE_COUNT = 5;
export const COLOR_EXTENDED_HUE_COUNT = 7;
export const PRIMARY_COLOR_HUE_IDX = 2;
export const PRIMARY_COLOR_EXTENDED_HUE_IDX = 3;
export const SECONDARY_COLOR_HUE_IDX = 1;
export const multiHueColorsColorPalette = {
    RED_YELLOW: [
        '#ffffb2',
        '#fddd87',
        '#fba35d',
        '#f75534',
        '#f9140a',
        '#d70315',
        '#b10026',
    ],
    BLUE: [
        '#f7fbff',
        '#cfe0f9',
        '#a6c6f3',
        '#77aded',
        '#3295e6',
        '#287ac6',
        '#1e60a6',
        '#144888',
        '#08306b',
    ],
    YELLOW_GREEN: [
        '#ffffe5',
        '#d5f0ca',
        '#abe1af',
        '#7dd295',
        '#46c27b',
        '#34a165',
        '#238150',
        '#11623c',
        '#004529',
    ],
    PINK: [
        '#f7f4f9',
        '#f5cfec',
        '#f1aadf',
        '#eb83d2',
        '#e356c5',
        '#c44198',
        '#a52c6d',
        '#861744',
        '#67001f',
    ],
    YELLOW_GREEN_BLUE: [
        '#ffffd9',
        '#d7f1da',
        '#abe2db',
        '#78d4db',
        '#1ac5db',
        '#2397b9',
        '#226c97',
        '#194377',
        '#081d58',
    ],
    REDS: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d',
    ],
    PURPLES: [
        '#fcfbfd',
        '#e6d0f8',
        '#cda6f3',
        '#b27ced',
        '#9450e6',
        '#7e3dcb',
        '#692bb0',
        '#541796',
        '#3f007d',
    ],
};
const isPrimaryColor = (index) => index % COLOR_HUE_COUNT === PRIMARY_COLOR_HUE_IDX;
const isPrimaryExtendedColor = (index) => index % COLOR_EXTENDED_HUE_COUNT === PRIMARY_COLOR_EXTENDED_HUE_IDX;
const getPrimaryColors = (colors) => [
    _.filter(colors, (__, index) => isPrimaryColor(index)),
];
const getPrimaryExtendedColors = (colors) => [
    _.filter(colors, (__, index) => isPrimaryExtendedColor(index)),
];
const getSecondaryColors = (colors) => {
    const colorPaletteList = [];
    // eslint-disable-next-line array-callback-return
    colors.forEach((color, index) => {
        const paletteIndex = index % COLOR_HUE_COUNT;
        let palette = colorPaletteList[paletteIndex];
        if (!palette) {
            palette = [];
        }
        palette.push(color);
        colorPaletteList[paletteIndex] = palette;
    });
    const secondaryColorPaletteList = _.remove(colorPaletteList, (__, index) => !isPrimaryColor(index));
    return secondaryColorPaletteList;
};
const getSecondaryExtendedColors = (colors) => {
    const colorPaletteList = [];
    // eslint-disable-next-line array-callback-return
    colors.forEach((color, index) => {
        const paletteIndex = index % COLOR_EXTENDED_HUE_COUNT;
        let palette = colorPaletteList[paletteIndex];
        if (!palette) {
            palette = [];
        }
        palette.push(color);
        colorPaletteList[paletteIndex] = palette;
    });
    const secondaryColorPaletteList = _.remove(colorPaletteList, (__, index) => !isPrimaryExtendedColor(index));
    return secondaryColorPaletteList;
};
const getFullColours = (colors) => {
    const colorPaletteList = [];
    // eslint-disable-next-line array-callback-return
    colors.forEach((color, index) => {
        const paletteIndex = index % COLOR_FULL_HUE_COUNT;
        if (!colorPaletteList[paletteIndex]) {
            colorPaletteList[paletteIndex] = [];
        }
        colorPaletteList[paletteIndex].push(color);
    });
    return colorPaletteList;
};
const defaultColors = _.flatten(_.values(defaultColorPalette));
const defaultFullColours = _.flatten(_.values(defaultFullColorPalette));
const defaultExtendedColors = _.flatten(_.values(defaultExtendedColorPalette));
const whiteColor = '#FFFFFF';
const grayscaleColors = [
    [
        '#F6F8FA',
        '#EAEDF2',
        '#DBDFE7',
        '#A5ACB9',
        '#777E8B',
        '#4A515E',
        '#323946',
        '#1D232F',
    ],
];
export { defaultColors, defaultFullColours, defaultExtendedColors, grayscaleColors, whiteColor, getPrimaryColors, getPrimaryExtendedColors, getSecondaryColors, getSecondaryExtendedColors, getFullColours, };
//# sourceMappingURL=color-constant.js.map